import React, { useEffect } from 'react';

import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { useDecryptedPayloadQuery } from '../../../api/tenant/queries/use-encrypt-query';
import { SplitView } from '../../split-view';
import { ResetPasswordForm } from '../forms/ResetPasswordForm';

type DecryptedPaylaod = {
  email: string;
  expireDate: string;
};

export const ResetPassword = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const [decryptedPaylaod, setDecryptedPayload] =
    React.useState<DecryptedPaylaod>();
  const queryParams = new URLSearchParams(location.search);
  const encryptedPayload = queryParams.get('data');
  const { data, loading } = useDecryptedPayloadQuery({
    payload: encryptedPayload ?? '',
  });

  const isWithinLast24Hours = (givenDateString: string): boolean => {
    if (!givenDateString) return false;
    const givenDate = new Date(givenDateString);
    const currentDate = new Date();
    const timeDifference = givenDate.getTime() - currentDate.getTime();
    const fiveMinutesInMillis = 24 * 60 * 60 * 1000; //5 * 60 * 1000;
    return timeDifference <= fiveMinutesInMillis;
  };

  useEffect(() => {
    if (!data) return;
    try {
      const load = JSON.parse(data.getDecryptedPayload?.payload);
      setDecryptedPayload(load);
    } catch {
      setDecryptedPayload(undefined);
    }
  }, [data]);

  return (
    <SplitView title={t('resetpassword.title')}>
      {loading && <Box>loading</Box>}
      {decryptedPaylaod &&
      !loading &&
      isWithinLast24Hours(decryptedPaylaod.expireDate) ? (
        <ResetPasswordForm email={decryptedPaylaod.email} />
      ) : (
        <Box>
          {t('registration.page.notvalid', {
            defaultValue: 'The link is expired',
          })}
        </Box>
      )}
    </SplitView>
  );
};
